import { api } from "../helpers";

const prefix = "/assets";

export const getAssetsList = (param, token) => {
	return api(`${prefix}`, "GET", undefined, param, token);
};

export const postAsset = (payload, token) => {
	const { file, ...rest } = payload;

	const formData = new FormData();
	formData.append("file", file);

	return api(`${prefix}`, "POST", formData, rest, token, "");
};

export const updateAsset = (payload, token) => {
	const { file, ...rest } = payload;

	const formData = new FormData();
	formData.append("file", file);

	return api(`${prefix}`, "PUT", formData, rest, token, "");
};
